module.exports = __webpack_public_path__ + "img/panier-bleu.f12559cb.png";